import React from 'react';
import { t } from '../../services/translations';
import { TextInput, TextInputProps } from './TextInput';

export function SearchTextInput({ leftIcon, placeholder, ...props }: TextInputProps) {
  return <TextInput leftIcon={leftIcon || 'search'} placeholder={placeholder || t('i_search')} {...props} />;
}
